// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ogGgF9bkL4UP6gov {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: calc(100vh - 97px);
  position: relative;
}

@media screen and (max-width: 1280px) {
  .ogGgF9bkL4UP6gov {
    min-height: calc(100vh - 65px);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/PrivateRoute.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE;IACE,8BAA8B;EAChC;AACF","sourcesContent":[".mainWrapper {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: space-between;\r\n  min-height: calc(100vh - 97px);\r\n  position: relative;\r\n}\r\n\r\n@media screen and (max-width: 1280px) {\r\n  .mainWrapper {\r\n    min-height: calc(100vh - 65px);\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
export var mainWrapper = `ogGgF9bkL4UP6gov`;
export default ___CSS_LOADER_EXPORT___;
